// @flow

import React, { Component } from 'react';
import './Pulldown.css';

class Pulldown extends Component {
  render() {
    const {
      enabled,
      filterName,
      label,
      onFilterChange,
      options,
      value,
    } = this.props;

    const onValueChange = event => {
      onFilterChange({ filterName, enabled, value: event.target.value });
    };

    const onEnabledChange = event => {
      onFilterChange({ filterName, enabled: !enabled, value });
    };

    return (
      <div className="Pulldown filter">
        <div className="top">
          <label>
            <input
              type="checkbox"
              onChange={onEnabledChange}
              checked={enabled}
            />
            {label}
          </label>
        </div>
        {enabled &&
          <div className="control">
            <select value={value} name={filterName} onChange={onValueChange}>
              {value === -1 && <option value={-1}>Make a selection</option>}
              {options.map(opt => {
                return (
                  <option value={opt.value} key={opt.value}>
                    {opt.name}
                  </option>
                );
              })}
            </select>
          </div>}
      </div>
    );
  }
}

export default Pulldown;



// WEBPACK FOOTER //
// ./src/components/Pulldown/Pulldown.js